import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dn7hrujbc: FaireProductEntity = {
  token: "p_9dn7hrujbc",
  type: "product",
  name: "Comfy Cute Boho Style Patchwork Pants Bright",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/a5f60a4b1001b3ce944eed5eaed370c9b687caf99c9c020d3162882c9c1a4521.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2946742d35e03f020f3322a3949049f3c003a16e366cea6aaf0fd86fd8a7c45e.jpeg",
    "https://cdn.faire.com/fastly/c90ba28ff5cc164264fbbd1182f0bffaa7bdc429900fdd6c793d45422db5d202.jpeg",
    "https://cdn.faire.com/fastly/3583c717f7a89eb1fd31de1541eca5374e6714d00740f6dd703b14eb1ba52ebd.jpeg",
    "https://cdn.faire.com/fastly/b003a2316305e3a64b61d78f4fe887b0c62fd8b9dadf2d6d177a3b25ccc33600.jpeg",
    "https://cdn.faire.com/fastly/8a1250524d609ab7d345a56fefd5c895c2d0ea3ce55c939c51204a2d49e6de74.jpeg",
    "https://cdn.faire.com/fastly/13c59656eeb07d9b8f7804dcce29277dab6413dda6c035bdbc8cd6c02660fe4b.jpeg",
    "https://cdn.faire.com/fastly/c009d8ee281fed46a954df58eb6449ecc7c14468556f946f7354c8b151e18bcf.jpeg",
    "https://cdn.faire.com/fastly/3acbaf1883948577bf016e184afe391ab4a939878466a2b523844d61cea80e70.jpeg",
    "https://cdn.faire.com/fastly/745298d39935a234abaa4a70e2556ba5fb364bc40d0607c9af45874d79293e5c.jpeg",
  ],
  priceDollars: 28.5,
  description:
    "These pants are JUST what you've been looking for. With it's cute and trendy patterns and colors, no wonder even modern teenagers are RAVING. Wear them out to go shopping, to festivals, out jogging, running errands, or even just when lying around at home. Pair these beauties with a plain black or white shirt for that simple but elegant look OR match your shirt with some of the secondary colors in the stripes for an outfit that really POPS. You can even change the overall look of the pants by cuffing the straight leg to show off your shoes! (Go ahead...zoom in for a closer look.) To only add to the appeal of these pants, these pants have an elastic waist tie/drawstring as well as POCKETS!",
  tags: [],
  msrpDollars: 57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:03.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
